
<div class="loader">
  <div class="shadow shadow-1" />
  <div class="box box-1" />
  <div class="shadow shadow-2" />
  <div class="box box-2" />
  <div class="shadow shadow-3" />
  <div class="box box-3" />
</div>
